import React from 'react';
import { motion } from 'motion/react';
import { ArrowRight } from 'lucide-react';

export const HeroCTAButton: React.FC = () => {
  return (
    <div className="inline-block outline-none group relative rounded-2xl w-full sm:w-[240px] h-[52px] md:h-[56px]">
      <motion.div
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
        className="relative w-full h-full rounded-2xl shadow-lg hover:shadow-2xl hover:shadow-primary/20 transition-shadow duration-500"
      >
        {/* Animated Glow Border Effect */}
        <div className="absolute inset-[-2px] rounded-[18px] overflow-hidden pointer-events-none">
          <div 
            className="absolute inset-[-100%] animate-[spin_10s_linear_infinite]"
            style={{
              background: 'conic-gradient(from 0deg, transparent 20%, #7C5CFF 40%, #6D5EF5 60%, #5B4AF7 80%, #8E7CFF 90%, transparent 100%)'
            }}
          />
        </div>



        {/* Inner Button Content */}
        <div className="relative w-full h-full bg-[#18181b] hover:bg-[#1f1f23] rounded-2xl flex items-center justify-center gap-2 shadow-[inset_0_1px_1px_rgba(255,255,255,0.15)] z-10 transition-colors duration-300">
          <span className="text-white font-medium text-base md:text-lg tracking-wide">
            Start Design
          </span>
          <ArrowRight 
            className="w-4 h-4 md:w-5 md:h-5 text-white/90 group-hover:text-white group-hover:translate-x-1 transition-all duration-300" 
            strokeWidth={2.5} 
          />
        </div>
      </motion.div>
    </div>
  );
};
